module.exports = __webpack_public_path__ + "assets/img/mh2.969de912.jpg";